
<template>
    
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 姓名" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					
            	<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加學生</el-button>
				
					<el-upload
						action="/admin/data/importExcelTopic"  
						:before-upload="beforeUpload"
						:headers="{token:$store.state.user.token}"
						:on-success="handleSuccess"
						:on-error="handleError"
						:show-file-list="false"
						accept=".xlsx,.xls"
					>
						<el-button class="mr-2" type="warning" size="mini">上傳學生Excel文件</el-button>
					</el-upload>
					
					<el-button @click="downloadTemplate" class="mr-2" type="success" size="mini">下載學生模版文件</el-button>
					<el-button @click="printTemplate(1)" class="mr-2" type="danger" size="mini">搜索導出pdf</el-button>
					<el-button @click="printTemplate(2)" class="mr-2" type="danger" size="mini">搜索導出pdf（郵箱）</el-button>
					<!-- <el-button @click="printTemplateAll" class="mr-2" type="danger" size="mini">勾選導出pdf</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="姓名" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索姓名"></el-input>
						</el-form-item>
						
						<el-form-item label="班別" class="mb-0">
							<el-input size="small" v-model="from.class_id" placeholder="搜索班別"></el-input>
						</el-form-item>

						<el-form-item label="學號" class="mb-0">
							<el-input size="small" v-model="from.number" placeholder="搜索學號"></el-input>
						</el-form-item>

						<el-form-item label="顯示待選擇" class="mb-0">
							<el-select v-model="from.del_status" size="small" placeholder="請選擇登錄狀態">
								<el-option label="不要顯示" :value="1"></el-option>
								<el-option label="顯示" :value="0"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="年級" >
							<el-select v-model="from.grade_id">
								<el-option
								:key="0"
								label="全部"
								:value=-1>
								</el-option>
								<el-option
								v-for="item in rule_list"
								:key="item.id"
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>


                        <el-form-item label="登錄狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇登錄狀態">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="啟用" :value="1"></el-option>
								<el-option label="禁用" :value="0"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="選擇比賽" prop="com_id" >
							<el-select
								size="small" 
								v-model="from.com_id"
								filterable
								remote
								reserve-keyword
								placeholder="請輸入關鍵詞:比賽編號 - 機構 - 比賽標題"
								:remote-method="remoteMethod"
								:loading="loading">
								<el-option
								v-for="item in ComOptions"
								:key="item.id"
								:label="item.str_name"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>
        

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>
				<el-table-column align="center" width="120" prop="id_str" label="編號">
				</el-table-column>
				<el-table-column align="center" width="60" prop="grade_name" label="年級">
				</el-table-column>

				<el-table-column align="center" width="60" prop="class_id" label="班別">
				</el-table-column>

				<el-table-column align="center" width="60" prop="number" label="學號">
				</el-table-column>

				<el-table-column align="center" prop="name" label="姓名">
				</el-table-column>
				
				<el-table-column align="center" prop="name_en" label="英文姓名">
				</el-table-column>
				
                	
                <el-table-column align="center" width="80" prop="head" label="頭像">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.head" 
						    >
						  </el-image>
					</template>
				</el-table-column>

				<el-table-column align="center" width="60" prop="level" label="等級">
				</el-table-column>


				<el-table-column align="center"  prop="from_type"  label="類型">
					<template slot-scope="v">
						<span style="color: red;" v-if="v.row.from_type==1">自行註冊</span>
						<span class="text-success" v-if="v.row.from_type==2">學校添加</span>
					</template>
				</el-table-column>
              
				
				<el-table-column align="center" prop="login_time" width="200" label="最近登錄">
				</el-table-column>

				<el-table-column type="expand" label="詳情"  width="80">
                    <template slot-scope="props">
                        <el-form inline class="demo-table-expand">
                            <el-form-item label="暱稱">
                                <span>{{ props.row.username }}</span>
                            </el-form-item>
                            <el-form-item label="生日">
                                <span>{{ props.row.birthday }}</span>
                            </el-form-item>
                            <el-form-item label="郵箱">
                                <span>{{ props.row.email }}</span>
                            </el-form-item>
							<el-form-item label="聯絡電話">
                                <span>{{ props.row.phone }}</span>
                            </el-form-item>
                            <el-form-item label="聯絡地址">
                                <span>{{ props.row.address }}</span>
                            </el-form-item>
							<el-form-item label="聯絡電郵">
                                <span>{{ props.row.link_email }}</span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>

				
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="220" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="openComModel(scope.row)"  v-auth="'delRule'" size="mini" plain type="warning">參賽詳情</el-button>
							<el-button @click="openModel(scope.row)"  v-auth="'delRule'" size="mini" plain type="primary">修改</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val"  size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false" 
			title="參賽記錄" 
			:visible.sync="createComModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '80%'">
			
			<div style="max-height: 65vh; overflow: auto;">
				<el-table :data="tableComData" border style="width: 100%">
					
					<el-table-column align="center" width="100" prop="time" label="參加時間">
					</el-table-column>
					<el-table-column align="center" prop="title" label="比賽">
					</el-table-column>
					<el-table-column align="center" prop="zu_name" label="參賽組別">
					</el-table-column>
					<el-table-column align="center"  width="100" prop="g_name" label="年級">
					</el-table-column>
					<el-table-column align="center"  width="100" prop="rank_name" label="結果">
					</el-table-column>
					
				</el-table>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<div style="flex: 1;" class="px-2">
					<el-pagination :current-page="pageCom.current" :page-sizes="pageCom.sizes" :page-size="pageCom.size" @size-change="handleSizeComChange"
					@current-change="handleCurrentComChange" layout="total, sizes, prev, pager, next, jumper" :total="pageCom.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>

		<el-dialog  :close-on-click-modal="false" 
			:title="editIndex > -1 ? '修改學生資料' : '添加學生'"
			:visible.sync="createModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '50%'">
			
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rules" ref="formEdit" :model="form" 
					:label-width="layout.is_phone ? '80px' : '100px'" 
					:label-position="layout.is_phone ? 'top' : 'left'">

					<el-form-item label="學生編號" prop="user_no">
						<el-input type="text" v-model="form.user_no" disabled placeholder="學生編號" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>

					<el-form-item v-if="editIndex > -1" label="原密碼" prop="pass">
						<el-input type="text" v-model="form.pass" disabled placeholder="原密碼" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="郵箱" prop="email">
						<el-input type="text" v-model="form.email" placeholder="郵箱" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					

					<el-form-item label="聯絡電話" prop="phone">
						<el-input type="text" v-model="form.phone" placeholder="聯絡電話" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>

					<el-form-item label="聯絡電郵">
						<el-input type="text" v-model="form.link_email" placeholder="聯絡電郵" clearable size="small" style="width: 85%;"></el-input>
                    </el-form-item>
					
					<el-form-item label="姓名" prop="name">
						<el-input type="text" v-model="form.name" placeholder="姓名" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="姓名（英文）" prop="name_en">
						<el-input type="text" v-model="form.name_en" placeholder="姓名（英文）" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="性別">
						<el-radio-group v-model="form.sex">
							<el-radio :label="1">男</el-radio>
							<el-radio :label="2">女</el-radio>
						</el-radio-group>
					</el-form-item>
					
					<el-form-item label="暱稱" prop="username">
						<el-input type="text" v-model="form.username" placeholder="暱稱" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="年級" prop="grade_id">
						<el-select v-model="form.grade_id">
							<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="班別" prop="class_id">
						<el-input type="text" v-model="form.class_id" placeholder="班別" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="學號" prop="number">
						<el-input type="text" v-model="form.number" placeholder="學號" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="密碼" prop="password">
						<el-input type="text" v-model="form.password" placeholder="密碼" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	

	</div>
</template>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	import { MessageBox } from 'element-ui';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {

				pageCom: {
					current: 1,
					sizes: [10, 20, 50, 100],
					size: 10,
					total: 0
				},
				
				createComModel:false,
				tableComData:[],
			
                rules: {
					name: [{
							required: true,
							message: "姓名不能為空",
							trigger: 'blur',
						},
					],
					class_id: [{
							required: true,
							message: "班別不能為空",
							trigger: 'blur',
						},
					],
					number: [{
							required: true,
							message: "學號不能為空",
							trigger: 'blur',
						},
					],
					grade_id: [{
							required: true,
							message: "請選擇年級",
							trigger: 'blur',
						},
					],
				},

				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					number: '',
					class_id: '',
					del_status: 1,
					grade_id:-1,
					com_id:null,
					status: -1,
				},
				exportUrl: null, // 存储接口返回的 URL
				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/UserList", //列表地址
                addUrl: "data/addUser", //修改密碼
				delAllUrl: "data/delUserAll", //批量删除地址
				delUrl: "data/delUser", //删除單条地址
                editStatusUrl: "data/editStatusUser", //修改狀態地址

				user_id: 0,
				tableData: [],
				form: {
					id: 0,
						name:'',
						sex:1,
						name_en:'',
						username:'',
						grade_id:'',
						class_id:'',
						number:'',
						email:'',
						phone:'',
                        pass: '',
                        link_email: '',
                        password: '',
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				ComOptions: [],
				loading:false,

			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['grade_list']);
		},
		methods: {
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getComOptionList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.ComOptions = all.data.list;
						this.loading = false;
					}).catch(err => {
						// 失敗
						this.ComOptions = [];
						this.loading = false;
					})
				} else {
					this.ComOptions = [];
					this.loading = false;
				}
			},
			handleCurrentComChange(val) {
				this.pageCom.current = val
				this.getComModelList()
			},
			handleSizeComChange(val) {
				this.pageCom.size = val
				this.getComModelList()
			},
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			downloadTemplate() {
				// 文件的 URL (可以是相對路徑或完整URL)
				// const baseUrl = 'https://api.freetraderex.com';
				const baseUrl = 'https://api.lets-go.fun';
				const filePath = '/excel/學生模版文件.xlsx';
				const fileUrl = `${baseUrl}${filePath}`;
				const link = document.createElement('a');
				link.href = fileUrl;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link); // 移除鏈接節點
			},
			getComModelList(){
				this.axios.post('/admin/data/getUserCom', {id:this.user_id,page:this.pageCom}, {
					token: true,
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.tableComData = all.data.list.list
						this.pageCom.total = all.data.list.total
					}else{
						this.$message.error('操作失敗');
					}
					
				}).catch(err => {
					// 失敗
					this.$message.error('操作失敗');
				})
			},
			openComModel(row){
				this.user_id = row.id;
				this.axios.post('/admin/data/getUserCom', {id:row.id,page:this.pageCom}, {
					token: true,
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						
						this.tableComData = all.data.list.list
						this.pageCom.total = all.data.list.total
						this.createComModel = true
					}else{
						this.createComModel = false
					}
					
				}).catch(err => {
					this.createComModel = false
				})
			},
			printTemplate(type_pdf=1) {
				this.from.ids = this.ids;
				this.from.type_pdf = type_pdf;
				if(!this.from.name && !this.from.class_id && !this.from.number && !this.from.grade_id && this.ids.length === 0){
					this.$confirm('當前未選擇條件，將會導出所有數據，是否繼續?', '提示', {
						confirmButtonText: '導出',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.layout.loading = true;
						this.axios.post('/admin/data/printTemplate', this.from, {
						token: true,
					}).then(res => {
						let all = res.data
						if (all.code == 1) {
							this.exportUrl = all.data.list;

							// 弹出询问框，用户手动点击后打开
							this.$confirm('導出已經完成，是否打開？', '提示', {
								confirmButtonText: '打開',
								cancelButtonText: '取消',
								type: 'success'
							}).then(() => {
								// 用户点击 "打开" 后跳转（不会被拦截）
								window.open(this.exportUrl, '_blank');

								this.$message({
									message: '導出完成',
									type: 'success'
								}); // 控制是否顯示成功提示
							})

							
							
						}else{
							this.$message.error('操作失敗');
						}
						this.layout.loading = false;
						}).catch(err => {
							// 失敗
							this.$message.error('操作失敗');
							this.layout.loading = false;
						})
					})
				}else{
					this.layout.loading = true;
					this.axios.post('/admin/data/printTemplate', this.from, {
						token: true,
					}).then(res => {
						let all = res.data;
						if (all.code == 1) {
							this.exportUrl = all.data.list;

							// 弹出询问框，用户手动点击后打开
							this.$confirm('導出已經完成，是否打開？', '提示', {
								confirmButtonText: '打開',
								cancelButtonText: '取消',
								type: 'success'
							}).then(() => {
								// 用户点击 "打开" 后跳转（不会被拦截）
								window.open(this.exportUrl, '_blank');

								this.$message({
									message: '導出完成',
									type: 'success'
								}); // 控制是否顯示成功提示
							})
						} else {
							this.$message.error('操作失敗');
						}
						this.layout.loading = false;
					}).catch(err => {
						// 失敗
						this.$message.error('操作失敗');
						this.layout.loading = false;
					});
				}
			},
			printTemplateAll() {
				if (this.ids.length === 0) {
					return this.$message({
						message: '清先選擇需要導出的數據！',
						type: 'error'
					});
				}
				// this.layout.loading = true;
				this.axios.post('/admin/data/printTemplate', {ids:this.ids}, {
					token: true,
				}).then(res => {
					let all = res.data
					console.log(all)
					if (all.code == 1) {
							this.$message({
								message: '導出完成',
								type: 'success'
							}); // 控制是否顯示成功提示
						
						// 如果存在 all.code.list，则打开新页面
						if (all.data.list) {
							window.open(all.data.list, '_blank'); // '_blank' 打开新標籤页
						}
					}else{
						this.$message.error('操作失敗');
					}
					// this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.$message.error('操作失敗');
					// this.layout.loading = false;
				})
			},
			//提交
			submit() {
				this.$refs.formEdit.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				return isJPG && isLt2M;
			},
			
			// 打开模态框
			openModel(e, type) {
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						name: e.name,
						user_no: e.user_no,
						name_en: e.name_en,
						username:e.username,
						grade_id:e.grade_id,
						class_id:e.class_id,
						link_email:e.link_email,
						sex:e.sex,
						number:e.number,
						email:e.email,
						phone:e.phone,
						pass:e.pass,
						
                        password: '',
					}
                    // 如果是修改，密碼可以为空，不做必填验证
                    this.rules.password = [{
                        required: false,
                        message: "密碼不能為空",
                        trigger: 'blur',
                    }];
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						name:'',
						name_en:'',
						link_email:'',
						username:'',
						grade_id:'',
						sex:1,
						class_id:'',
						number:'',
						email:'',
						phone:'',
						password: '',
					}
					this.editIndex = -1

                    // 新增时，密碼是必填项
                    this.rules.password = [{
                        required: true,
                        message: "密碼不能為空",
                        trigger: 'blur',
                    }];
				}
				
				// 打开dialog
				this.createModel = true
			},
			// 上傳前的文件類型检查
			beforeUpload(file) {
				const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';
				if (!isExcel) {
					this.$message.error('只能上傳Excel文件');
				}
				this.layout.loading = true;  // 控制加載层的顯示
				return isExcel;
			},
			// 上傳成功回调
			handleSuccess(res, file, fileList) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res = JSON.parse(en_data)
				this.layout.loading = false;  // 控制加載层的顯示
				if(res.code==0){
					this.$message.error(res.msg);
				}else{
					this.$message.success('文件上傳成功');
					this.getList()
				}
			},
			// 上傳失敗回调
			handleError(error, file, fileList) {
				this.layout.loading = false;  // 控制加載层的顯示
				this.$message.error('文件上傳失敗');
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
            //公共列表
			commonList(type) {
               
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.rule_list = list.grade
                    if (this.rule_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.form.grade_id = this.rule_list[0].id;
					}
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					number: '',
					class_id: '',
					grade_id:-1,
					del_status: 1,
					com_id:null,
					status: -1,
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
